<mat-card-content>
    @for(  gloss of glosses; track gloss.gloss_id) {
        <app-gloss-selector-line [gloss]="gloss" [container]="verse" (action)="processGlossAction($event)"></app-gloss-selector-line>
    }
</mat-card-content>
